import { useFetchData } from "../../../hooks/useFetch";
import { BaseResponse } from "../../../models/response/base-response";
import { ApiConfig, API_RECEIPTS_ROUTER } from "../../../services/api-config";

export interface Receipt {
  id: number;
  company_id: number;
  user_id: number;
  receipt_category_id: number;
  approved_user_id?: number;
  rejected_user_id?: number;
  canceled_user_id?: number;
  reason?: string;
  reference_type?: number;
  reference_id?: number;
  amount: number;
  note?: string;
  type: number;
  status: number;
  transaction_date?: string;
  entry_type?: number;
  source_reference?: string;
  source_reference_id?: number;
  document_number?: string;
  created_at?: string;
  updated_at?: string;
  category_name?: string;
}

export interface ReceiptListParams {
  page?: number;
  limit?: number;
  key_search?: string;
  type?: number | null;
  status?: number;
}

export const ReceiptService = {
  list: () => {
    const { request, baseResponse, loading } = useFetchData.Get<Receipt>({ projectId: ApiConfig.PROJECT_ID.ACCOUNTING_SERVICE });
    return {
      fetch: (params: ReceiptListParams = {}) => request({ endPoint: API_RECEIPTS_ROUTER.API_LIST, data: { page: 1, limit: 50, key_search: "", type: null, status: 1, ...params } }),
      response: baseResponse,
      loading,
    };
  },
  create: () => {
    const { request, baseResponse, loading } = useFetchData.Post<BaseResponse<Receipt>>({ projectId: ApiConfig.PROJECT_ID.ACCOUNTING_SERVICE });
    return { fetch: (payload: Partial<Receipt>) => request({ endPoint: API_RECEIPTS_ROUTER.API_CREATE, data: payload }), response: baseResponse, loading };
  },
  update: () => {
    const { request, baseResponse, loading } = useFetchData.Post<BaseResponse<Receipt>>({ projectId: ApiConfig.PROJECT_ID.ACCOUNTING_SERVICE });
    return { fetch: (id: number, payload: Partial<Receipt>) => request({ endPoint: API_RECEIPTS_ROUTER.API_UPDATE(id), data: payload }), response: baseResponse, loading };
  },
  detail: () => {
    const { request, baseResponse, loading } = useFetchData.Get<Receipt>({ projectId: ApiConfig.PROJECT_ID.ACCOUNTING_SERVICE });
    return { fetch: (id: number) => request({ endPoint: API_RECEIPTS_ROUTER.API_DETAIL(id) }), response: baseResponse, loading };
  },
  changeStatus: () => {
    const { request, baseResponse, loading } = useFetchData.Post<BaseResponse<Receipt>>({ projectId: ApiConfig.PROJECT_ID.ACCOUNTING_SERVICE });
    return { fetch: (id: number, payload: { status: number; reason?: string }) => request({ endPoint: API_RECEIPTS_ROUTER.API_CHANGE_STATUS(id), data: payload }), response: baseResponse, loading };
  },
  countTab: () => {
    const { request, baseResponse, loading } = useFetchData.Get<{ [k: string]: number }>({ projectId: ApiConfig.PROJECT_ID.ACCOUNTING_SERVICE });
    return { fetch: (params: { key_search?: string; type?: number | null }) => request({ endPoint: API_RECEIPTS_ROUTER.API_COUNT_TAB, data: params }), response: baseResponse, loading };
  },
  incomeOverview: () => {
    const { request, baseResponse, loading } = useFetchData.Get<any>({ projectId: ApiConfig.PROJECT_ID.ACCOUNTING_SERVICE });
    return { fetch: (params: { from_date?: string; to_date?: string }) => request({ endPoint: API_RECEIPTS_ROUTER.API_INCOME_OVERVIEW, data: params }), response: baseResponse, loading };
  },
};

